import React from "react";
import { useParams, Link } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";
import blogs from "../../../data/blogs";
import Seo from "../../SEO/Seo";
import BlogArticle from "../BlogArticle";
import { SITE_URL, SITE_NAME } from "../../../config";
import "./BlogDetail.css";

const BlogDetail = () => {
  const { slug } = useParams();
  const blog = blogs.find((b) => b.slug === slug);

  if (!blog) {
    return (
      <div className="blog-detail-page">
        <Seo title="Yazı bulunamadı" />
        <div className="blog-detail-container blog-notfound">
          <h1>Yazı bulunamadı</h1>
          <Link to="/blog" className="back-link">
            <FiArrowLeft /> Blog'a Dön
          </Link>
        </div>
      </div>
    );
  }

  const shareUrl = `${SITE_URL}/blog/${blog.slug}`;
  const articleJsonLd = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: blog.title,
    description: blog.summary,
    image: blog.image ? `${SITE_URL}${blog.image}` : undefined,
    datePublished: blog.date,
    dateModified: blog.date,
    keywords: blog.tags ? blog.tags.join(", ") : undefined,
    author: blog.author
      ? blog.author.split(",").map((name) => ({ "@type": "Person", name: name.trim() }))
      : { "@type": "Organization", name: SITE_NAME },
    publisher: {
      "@type": "Organization",
      name: SITE_NAME,
      logo: { "@type": "ImageObject", url: `${SITE_URL}/shortlogoAphasiAI.svg` },
    },
    mainEntityOfPage: { "@type": "WebPage", "@id": shareUrl },
    articleSection: blog.category,
  };

  return (
    <>
      <Seo
        title={blog.title}
        description={blog.summary}
        image={blog.image}
        type="article"
        canonical={`/blog/${blog.slug}`}
        jsonLd={articleJsonLd}
      />
      <BlogArticle post={blog} />
    </>
  );
};

export default BlogDetail;
